import { render, staticRenderFns } from "./TaxRateForLandList.vue?vue&type=template&id=b57f82b2&scoped=true&"
import script from "./TaxRateForLandList.vue?vue&type=script&lang=js&"
export * from "./TaxRateForLandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57f82b2",
  null
  
)

export default component.exports